<template>
	<div class="chat_box">
		<div class="title">
			{{order_num}}
		</div>
		<div class="content_box" id="content_box">
			<div class="noData" v-if='txtList.length == 0'>暂无消息</div>
			<div v-for="(item,i) in txtList" :key="i">
				<div class="f_row al_itm " style="margin: 20px 30px;" v-if="item.from == 1">
					<i class="layui-icon px28;" style="border:1px solid;border-radius:50%;width:30px;height:30px;color:#FF9800;text-align: center;line-height: 30px;">&#xe66f;</i>
					<div class="f_col margin_l10">
						<span class="px12" style="margin-bottom:5px;font-size: 12px;color: #999;">{{item.time}}</span>
						<span class="px16" v-if="item.type == 1">{{item.content}}</span>
						<el-image v-if="item.type == 2" style="width: 300px;" :src="item.content" :preview-src-list="item.img"></el-image>
					</div>
				</div>
				<div class="f_row al_itm jc_end" style="margin: 20px 30px;" v-if="item.from == 2">
					<div class="f_col">
						<span class="px12" style="margin-bottom:5px;font-size: 12px;color: #999;text-align: right;">{{item.time}}</span>
						<span class="px16" v-if="item.type == 1">{{item.content}}</span>
						<el-image v-if="item.type == 2" style="width: 300px;" :src="item.content" :preview-src-list="item.img"></el-image>
					</div>
					<i class="layui-icon px28 margin_l10 zt_txt_color" style="border:1px solid;border-radius:50%;width:30px;height:30px;text-align: center;line-height: 30px;">&#xe66f;</i>
				</div>
			</div>
			<div id="bottom" style="height: 1px;"></div>
		</div>
		<div class="scektsBox f_row al_itm zt_color" style="border-top:1px solid #eee;">
			<button type="button" class="layui-btn zt_color" id="upload_img" style="padding:0 30px;border-radius:0;height:41px;">
                <i class="layui-icon layui-icon-picture"></i>
            </button>
			<div class="layui-input-inline" style="width:100%;">
				<input v-model="content" @keyup.enter="sendContent" style="border:none;" maxlength="180" type="text" name="content" autocomplete="off" class="layui-input">
			</div>
			<button @click="sendContent" type="button" class="layui-btn zt_color" style="padding:0 50px;border-radius:0;height:41px;">发送</button>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				layers: '',
				uploads: '',
				time: '',
				content: '',
				txtList: [],
				order_num: '',
				order_id: ''
			}
		},
		created() {
			this.order_num = this.$route.query.order_num;
			this.order_id = this.$route.query.id;
			this.getContent();
			this.time = setInterval(() => {
				this.getNewMsg();
			}, 5000)
		},
		destroyed: function() {　　　
			this.closeTime();
		},
		watch: {
			content(news, olds) {
				if(news.length == 180) {
					layer.msg('只能输入180个字符', {
						icon: 2,
						anim: 5
					})
				}
			}
		},
		mounted() {
			let _this = this;
			layui.use(['layer', 'upload'], () => {
				this.layers = layui.layer;
				this.uploads = layui.upload;
				this.uploads.render({
					elem: '#upload_img', //绑定元素
					url: 'https://mr.summary88.com/api/Common/OssUploadFile', //上传接口
					accept: 'file',
					number: 1,
					field: 'file',
					exts: 'jpg|jpeg|png|gif',
					before: function(obj) {
						layer.load(2); //上传loading
					},
					done: function(res) {
						layer.closeAll();
						api.sendMsg({
							token: _this.getCookie('token'),
							order_num: _this.order_num,
							order_id: _this.order_id,
							from_user: 1,
							type: 2,
							content: res.image_url,							
						}).then((res1) => {
							if(res1.code == 1) {
								_this.getContent();
							}
						})
					},
					error: function(err) {
						layer.closeAll();
						console.log(err) //请求异常回调
					}
				});
			});

		},
		methods: {
			getContent() { //获取消息列表
				let _this = this;
				api.getMsgList({
					token: this.getCookie('token'),
					order_num: this.order_num,
					from_user: 1,
				}).then((res) => {
					if(res.code == 1) {
						for(let i = 0; i < res.data.length; i++) {
							res.data[i].time = _this.getTimes(res.data[i].createtime);
							res.data[i].img = [];
							if(res.data[i].type == 2) {
								res.data[i].img[0] = res.data[i].content;
							}
						}
						_this.txtList = res.data;
						setTimeout(() => {
							_this.goToBottom();
						}, 300)
					}
				})
			},
			getNewMsg() { //获取新消息
				let _this = this;
				api.getNewMsgStatus({
					token: this.getCookie('token'),
					order_num: this.order_num,
					type: 1,
					from_user: 1, //1工程师发送，2企业发送
				}).then((res) => {
					if(res.code == 1) {
						_this.getContent();
					}
				})
			},
			closeTime() {
				clearInterval(this.time);
			},
			sendContent() { //发送消息
				let _this = this;
				if(this.content == "") {
					layer.msg('输入框未检测到内容', {
						icon: 2,
						anim: 6
					});
					return false;
				} else {
					api.sendMsg({
						token: this.getCookie('token'),
						order_num: this.order_num,
						order_id: this.order_id,
						from_user: 1,
						type: 1,
						content: this.content
					}).then((res) => {
						if(res.code == 1) {
							_this.content = '';
							_this.getContent();
						}
					})
				}
			},
			goToBottom() {
				var myElement = document.getElementById('bottom');
				var topPos = myElement.offsetTop;
				document.getElementById('content_box').scrollTop = topPos;
			}
		},
	}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.noData {
		text-align: center;
		line-height: 30px;
		color: #999;
		font-size: 14px;
	}
	
	.chat_box {
		width: 100%;
		height: calc(100vh - 100px);
		box-sizing: border-box;
		padding-top: 50px;
		padding-bottom: 50px;
		position: relative;
		margin-bottom: -15px;
	}
	
	.chat_box .title {
		position: absolute;
		top: 0;
		left: -15px;
		width: calc(100% + 30px);
		height: 50px;
		line-height: 50px;
		background: #FFF;
		text-align: center;
		font-size: 18px;
		font-weight: bold;
		border-top: 1px solid #EEEEEE;
		border-bottom: 1px solid #EEEEEE;
		-moz-user-select: none;
		-webkit-user-select: none;
		user-select: none;
	}
	
	.content_box {
		height: 100%;
		box-sizing: border-box;
		overflow-x: hidden;
		overflow-y: auto;
	}
	
	.scektsBox {
		position: absolute;
		bottom: 0;
		left: -15px;
		width: calc(100% + 30px);
	}
</style>


// WEBPACK FOOTER //
// src/components/communicate.vue